export default __webpack_public_path__ + "assets/soi_profile.3a4e3407.jpg";